import React, { useState, useEffect } from "react";
import { csv } from "d3-fetch";
import { scaleLinear } from "d3-scale";
import {
  ComposableMap,
  Geographies,
  Geography,
  Sphere,
  Graticule,
  Marker,
} from "react-simple-maps";
import { geoCentroid } from "d3-geo";
import { Tooltip } from "react-tooltip";


const geoUrl = "https://unpkg.com/world-atlas@2.0.2/countries-110m.json";

const colorScale = scaleLinear().domain([1, 75]).range(["#ffedd5", "#ea580c"]);

const materialList = ["Ciment", "Bois", "MateriauxDivers", "Metaux", "Briques"];

const MapComponent = () => {
  const [data, setData] = useState([]);
  const [selectedMaterial, setSelectedMaterial] = useState("Total");
  const [content, setContent] = useState({ Pays: '', Empreinte: '', Stress: '' });


  useEffect(() => {
    csv("/data/provenance_materiaux_construction.csv").then((csvData) => {
      const parsedData = csvData.map((row) => ({
        Pays: row.Pays,
        Pays2: row.Pays2,
        Ciment: parseFloat(row.Ciment.replace(",", ".")) || 0,
        Bois: parseFloat(row.Bois.replace(",", ".")) || 0,
        MateriauxDivers: parseFloat(row['Matériaux de construction'].replace(",", ".")) || 0,
        Metaux: parseFloat(row['Elements en métal pour la construction'].replace(",", ".")) || 0,
        Briques: parseFloat(row['Briques, tuiles et produits en terre cuite'].replace(",", ".")) || 0,
        Coefficient_AWARE: parseFloat(row.Coefficient_AWARE.replace(",", ".")) || 0,
      }));
      setData(parsedData);
    });
  }, []);

  const handleMouseEnter = (name, totalValue, coefAware) => {
    console.log(contentString)
    setContent({
      Pays: `${name}`,
      Empreinte: `Empreinte : ${totalValue.toFixed(0)} L/Jour`,
      Stress: `Stress hydrique: ${coefAware}`
    });
    console.log(contentString)

  };

  const handleMouseLeave = () => {
    setContent({ Pays: '', Empreinte: '', Stress: '' });
  };

  const contentString = Object.values(content).join('<br />');



  const getTotalFootprint = (d) => {
    return selectedMaterial === "Total"
      ? d.Ciment + d.Bois + d.MateriauxDivers + d.Metaux + d.Briques
      : d[selectedMaterial];
  };

  const buttonStyle = (isSelected) => ({
    padding: "10px 20px",
    border: "2px solid #FF8000", // Orange plus vif
    borderRadius: "25px", // Coins bien arrondis
    backgroundColor: isSelected ? "#FF8000" : "#FFFFFF",
    color: isSelected ? "#FFFFFF" : "#FF8000",
    cursor: "pointer",
    fontWeight: "bold",
    transition: "all 0.3s ease-in-out", // Transition fluide
  });

  return (
    <div>
      <div style={{ marginBottom: 10, display: 'flex', gap: '20px', justifyContent: 'center' }}>
        <button 
        style={buttonStyle(selectedMaterial === "Total")}
        onClick={() => setSelectedMaterial("Total")}>Tout</button>
        {materialList.map((mat) => (
          <button 
          style={buttonStyle(selectedMaterial === mat)}
          key={mat} 
          onClick={() => setSelectedMaterial(mat)}>
            {mat}
          </button>
        ))}
      </div>

      <ComposableMap 
        width={800}
        height={400}
        style={{ width: "100%" }}
        projectionConfig={{ rotate: [-10, 0, 0], scale: 147 }}
        data-tooltip-id="map"
      >
        <Sphere stroke="#E4E5E6" strokeWidth={0.5} />
        <Graticule stroke="#E4E5E6" strokeWidth={0.5} />

        <Geographies geography={geoUrl}>
            {({ geographies }) => (
              <>
                <g style={{ position: 'relative', zIndex: 1 }}>
                  {geographies.map((geo) => {
                    const countryData = data.find((d) => d.Pays2 === geo.properties.name);
                    const coefAware = countryData ? countryData.Coefficient_AWARE : 0;
                    const frenchName = countryData ? countryData.Pays : '';
                    const totalValue = 0;

                    return (
                      <Geography
                        key={geo.rsmKey}
                        geography={geo}
                        onMouseEnter={() => handleMouseEnter(frenchName, totalValue, coefAware)}
                        onMouseLeave={handleMouseLeave}
                        style={{
                          default: {
                            outline: "none",
                            fill: countryData ? colorScale(coefAware) : "#F5F4F6",
                            stroke: "white",
                            strokeWidth: 0.6,
                          },
                          hover: {
                            outline: "none",
                            fill: countryData ? colorScale(coefAware) : "#F5F4F6",
                            stroke: "white",
                            strokeWidth: 0.6,
                          },
                          pressed: {
                            outline: "none",
                            fill: countryData ? colorScale(coefAware) : "#F5F4F6",
                            stroke: "white",
                            strokeWidth: 0.6,
                          },
                        }}
                      />
                    );
                  })}
                </g>
                <g style={{ position: 'relative', zIndex: 2 }}>
                  {geographies.map((geo) => {
                    const countryData = data.find((d) => d.Pays2 === geo.properties.name);
                    const coefAware = countryData ? countryData.Coefficient_AWARE : 0;
                    const frenchName = countryData ? countryData.Pays : '';


                    if (!countryData) return null;

                    const totalValue = geo ? getTotalFootprint(countryData)
                      : 0;
                    const centroid = geoCentroid(geo);
                    const radius = Math.sqrt(totalValue) * 2;

                    return (
                      totalValue > 0 && (
                        <Marker key={geo.rsmKey} coordinates={centroid}>
                          <circle
                            r={radius * 10}
                            fill={"rgba(32, 86, 115, 0.5)"}
                            stroke={"#205673"}
                            strokeWidth={0.5}
                            onMouseEnter={() => handleMouseEnter(frenchName, totalValue, coefAware)}
                            onMouseLeave={handleMouseLeave}
                          />
                        </Marker>
                      )
                    );
                  })}
                </g>
              </>
            )}
          </Geographies>



      </ComposableMap>
      <Tooltip
        id="map"
        content={contentString}
        float
        render={({ content }) => {
          console.log("Rendering Tooltip with content:", content);
          return content.includes("Empreinte :") ? <div dangerouslySetInnerHTML={{ __html: contentString }} /> : null;
        }}
        style={{ backgroundColor: "white", color: "#205673", fontWeight:'bold', zIndex:9999}}
      />

    </div>
  );
};

export default MapComponent;
